import Button from '@atlaskit/button';
import traceUFOPress from '@atlassian/react-ufo/trace-press';

import React, { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';

import { Dimensions } from 'components/visuals';
import { ORDER_INVOICE_ACTION_PDF_UFO_NAME } from 'util/ufoNameConstants';

import {
  StyledHistoryWrapper,
  StyledParagraph,
  StyledTextLabel,
} from '../licensesExpandedRow/StyledComponents';
import EndUserLicenseKeyDialog from './EndUserLicenseKeyDialog';
import { fetchLicenseById } from '../../duck/actions/license';
import { fetchInvoicePDF } from '../../duck/actions/invoices';
import { removeTimezone } from '../../common/utils';
import { route } from '../../duck/actions/orders';

const AccountHistoryItem = ({ period, handleInvoiceDownload, userPartnerId }) => {
  const dispatch = useDispatch();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const { paidDate, orderId, description, partnerId, licenseId } = period;
  const isPurchasedByLoggedInUser = userPartnerId === partnerId?.toString();

  useEffect(() => {
    if (licenseId) {
      dispatch(fetchLicenseById(licenseId));
    }
  }, []);

  return (
    <>
      <StyledTextLabel width="auto" textalign="center">
        <FormattedDate value={removeTimezone(paidDate)} day="2-digit" month="long" year="numeric" />
      </StyledTextLabel>
      <p>
        <Button
          appearance="link"
          key={orderId}
          onClick={(e) => handleInvoiceDownload(e, orderId, isPurchasedByLoggedInUser)}
        >
          AT-{orderId}
        </Button>
        <StyledParagraph padding={`0 ${Dimensions.units(1.25)}px`}>
          {!isPurchasedByLoggedInUser ? (
            <FormattedMessage
              defaultMessage="(Not purchased by you)"
              id="mac.licenses.history.partner.not-purchased-by-you"
            />
          ) : null}
        </StyledParagraph>
        <StyledParagraph padding={`0 ${Dimensions.units(1.25)}px`}>{description}</StyledParagraph>
        {isPurchasedByLoggedInUser && licenseId ? (
          <Button appearance="link" key={licenseId} onClick={() => setIsModalOpened(true)}>
            <FormattedMessage id="mac.licenses.view.license" defaultMessage="View license" />
          </Button>
        ) : null}
      </p>
      {licenseId ? (
        <EndUserLicenseKeyDialog
          licenseId={licenseId}
          isModalOpened={isModalOpened}
          setIsModalOpened={setIsModalOpened}
        />
      ) : null}
    </>
  );
};

const AccountHistoryAsPartner = ({ accountHistoryAsPartner, userPartnerId }) => {
  const dispatch = useDispatch();
  const handleInvoiceDownload = (e, cartId, isPurchasedByLoggedInUser) => {
    e.stopPropagation();

    if (isPurchasedByLoggedInUser) {
      traceUFOPress(ORDER_INVOICE_ACTION_PDF_UFO_NAME);
      dispatch(fetchInvoicePDF(cartId));
    } else {
      dispatch(redirect(route()));
    }
  };

  accountHistoryAsPartner?.sort((a, b) => {
    return new Date(a.paidDate).getTime() - new Date(b.paidDate).getTime();
  });

  return (
    <StyledHistoryWrapper data-cy="history-table">
      {accountHistoryAsPartner &&
        accountHistoryAsPartner.map((period) => {
          return (
            <AccountHistoryItem
              key={period.periodId}
              period={period}
              handleInvoiceDownload={handleInvoiceDownload}
              userPartnerId={userPartnerId}
            />
          );
        })}
    </StyledHistoryWrapper>
  );
};

export default AccountHistoryAsPartner;
